import { Route, Switch } from 'react-router-dom';

import About from '../components/About';
import FAQ from '../components/Faq';
import HomeNav from '../components/HomeNav';
import KctPage from '../components/KctPage';
import { Link } from 'react-router-dom';
import MerchantTermsAndConditions from '../components/MerchantTermsAndConditions';
import PaymentAuthorizationResult from '../components/PaymentAuthorizationResult';
import PrivacyPolicy from '../components/PrivacyPolicy';
import React from 'react';
import TermsOfUse from '../components/Terms-of-use';

const Static = (props) => (
  <div className='home-page'>
    <HomeNav />
    <Switch>
      <Route path='/faq' component={FAQ} />
      <Route path='/about' component={About} />
      <Route path='/privacy-policy' component={PrivacyPolicy} />
      <Route path='/terms-of-use' component={TermsOfUse} />
      <Route path='/payment-authorization-result' component={PaymentAuthorizationResult} />
    </Switch>
  </div>
);

export const ContentPages = (props) => (
  <div className="content__page__container">
    <header className="content-page">
      <div className="content-contact">Support 0201-229-3044</div>
      <div className="header">
        <Link className="content-logo" to="/" />
        <div className="content-nav">
          <Link to="/faq">FAQ</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
      </div>
      {/* <div className="linebreak">&nbsp;</div> */}
    </header>
    <Switch>
      <Route
        path="/content/merchants/tnc"
        component={MerchantTermsAndConditions}
      />
      <Route path="/about" component={About} />
      <Route path="/content/disco/kct" component={KctPage} />
    </Switch>
  </div>
);

export default Static;



// WEBPACK FOOTER //
// ./src/views/StaticPages.js